interface IconAbloWhiteProps {
  width?: number
  height?: number
}

const IconAbloWhite = ({ width = 47, height = 33 }: IconAbloWhiteProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 47 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9184 26.9188V5.35303H19.8397C21.4287 5.35303 22.5849 5.73529 23.3091 6.49887C24.0334 7.26245 24.3951 8.5226 24.3951 10.2793V11.2228C24.3951 12.2356 24.2109 13.0563 23.8426 13.6859C23.4743 14.3146 22.9133 14.7278 22.1606 14.9236C23.1449 15.169 23.8056 15.7424 24.1407 16.6447C24.4757 17.5479 24.6437 18.6478 24.6437 19.9473C24.6437 21.3442 24.5109 22.565 24.246 23.6106C23.9812 24.6562 23.5009 25.4694 22.806 26.0494C22.1112 26.6293 21.1221 26.9198 19.8388 26.9198H13.9175L13.9184 26.9188ZM18.189 13.477H19.0832C19.4885 13.477 19.7495 13.3215 19.8653 13.0113C19.9811 12.7012 20.039 12.3293 20.039 11.8964V9.72747C20.039 9.03321 19.7286 8.68562 19.1079 8.68562H18.189V13.477ZM18.6237 23.1197C19.7571 23.1197 20.3248 22.5884 20.3248 21.5269V18.8314C20.3248 18.2187 20.2317 17.7352 20.0457 17.3792C19.8596 17.0241 19.5094 16.8461 18.9968 16.8461H18.19V23.0953C18.3722 23.1122 18.5165 23.1197 18.6247 23.1197H18.6237Z"
      fill="white"
    />
    <path
      d="M25.2295 26.9188V5.35303H29.5997V23.2424H34.0934V26.9179H25.2295V26.9188Z"
      fill="white"
    />
    <path
      d="M39.6122 27.1147C37.8656 27.1147 36.531 26.5938 35.6083 25.5528C34.6857 24.511 34.2244 23.0063 34.2244 21.0379V10.7937C34.2244 8.94797 34.6819 7.54635 35.596 6.5907C36.5101 5.63505 37.8495 5.15723 39.6122 5.15723C41.3749 5.15723 42.7133 5.63505 43.6284 6.5907C44.5425 7.54635 45 8.94703 45 10.7937V21.0369C45 23.0054 44.5387 24.511 43.616 25.5519C42.6934 26.5938 41.3588 27.1137 39.6122 27.1137V27.1147ZM39.6492 23.145C40.3108 23.145 40.6421 22.5116 40.6421 21.2459V10.7197C40.6421 9.65815 40.3194 9.12692 39.6739 9.12692C38.9458 9.12692 38.5813 9.67033 38.5813 10.7562V21.2693C38.5813 21.9392 38.6639 22.4189 38.83 22.7093C38.9952 22.9998 39.2686 23.144 39.6492 23.144V23.145Z"
      fill="white"
    />
    <path
      d="M11.1173 5.35303H4.35313L2 26.9188H6.16426L6.58477 21.065H8.92176L9.37929 26.9188H13.4325L11.1173 5.35303ZM7.75801 18.644C6.95402 18.644 6.30285 18.0004 6.30285 17.2068C6.30285 16.4133 6.95497 15.7705 7.75801 15.7705C8.56106 15.7705 9.21318 16.4142 9.21318 17.2068C9.21318 17.9995 8.56106 18.644 7.75801 18.644Z"
      fill="white"
    />
  </svg>
)

export default IconAbloWhite
